import { render, staticRenderFns } from "./GaDashboard.vue?vue&type=template&id=0ecd8902&scoped=true"
import script from "./GaDashboard.vue?vue&type=script&lang=js"
export * from "./GaDashboard.vue?vue&type=script&lang=js"
import style0 from "./GaDashboard.vue?vue&type=style&index=0&id=0ecd8902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd8902",
  null
  
)

export default component.exports